import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkRateUpdate } from '../models/models'

export class UpdatePkRateApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/updateRate',
      requesterInfo,
    })
  }

  public async updateRate(request: IPkRateUpdate): Promise<string> {
    return await this.postAsync<string>(request)
  }
}
